<template>
	<div
		style="display: none"
		@click.stop="() => {}"
		id="datepicker-wrapper"
		class="datepicker-dropdown-wrapper position-relative font-roboto"
		ref="datepicker-wrapper"
	>
		<input ref="start-date" type="text" name="start" hidden />
		<input ref="end-date" type="text" name="end" hidden />

		<div
			class="planning-range-dropdown bg-white p-3"
			:class="
				endDatepickerOpen
					? 'datepickerEndDateStyle'
					: 'datepickerStartDateStyle'
			"
		>
			<div class="position-relative h-100">
				<div
					class="date-dropdown-header d-flex flex-row nowrap justify-content-between align-items-start mb-2"
				>
					<span
						v-if="datepickerOpen == 'start'"
						class="font-font-weight-600 font-size-18"
					>
						{{ content.planner_datePickerWhen }}
					</span>
					<span
						v-else-if="datepickerOpen == 'end'"
						class="font-font-weight-600 font-size-18"
					>
						{{ content.planner_datePickerWhenBack }}
					</span>
					<ClsBtn @click="handleClose" />
				</div>
				<div id="datepicker-container" ref="datepicker-container"></div>
				<!-- <button
                    @click.stop="() => handleValidateBtnClick()"
                    class="position-absolute validate-dates-btn bg-lighter-blue--text-white--hover-effect font-weight-600 font-18 p-2 cursor-pointer w-100 py-3 py-md-2 px-4"
                    :class="validateClassObj"
                    :disabled="!isDatesValid"
                >
                    <span>{{ content.planner_datePickerValidateChoice }}</span>
                </button> -->
			</div>

			<Overlay
				:position="'absolute'"
				:open="datepickerLoading"
				:classes="''"
				:color="'rgba(13, 20, 27, 0.65)'"
				:maxOpacity="1"
				zIndex="11"
			>
				<div v-if="datepickerLoading">
					<div class="loader position-fixed"></div>
				</div>
			</Overlay>
		</div>
	</div>
</template>

<script>
import Overlay from "@/vue/common/overlay.vue";
import { mapState, mapGetters } from "vuex";
import ClsBtn from "@/vue/common/clsBtn";
import store from "@/vue/planning/store/store";
import { Packages } from "@/enums/packages";

export default {
	store,
	name: "DatepickerDropdown",
	components: {
		Overlay,
		ClsBtn,
	},

	data() {
		return {
			libs: {
				DateRangePicker: null,
			},
			daterangepicker: null,
			endDatepickerOpen: false,
		};
	},

	computed: {
		...mapState([
			"content",
			"liheData",
			"packCode",
			"dates",
			"feature",
			"currentMonth",
			"datepickerStartDate",
			"datepickerEndDate",
			"currentFocusedDate",
			"datepickerLoading",
			"language",
			"datepickerOpen",
			"availableStartDateResponses",
			"availableEndDateResponses",
			"loading",
			"season",
		]),
		...mapGetters([
			"locale",
			"availableStartDates",
			"availableEndDates",
			"availableStartDatesSet",
			"availableEndDatesSet",
		]),

		validateClassObj() {
			const classes = [];
			if (!this.isDatesValid) {
				classes.push("disabled");
			}
			if (this.datepickerStartDate) {
				classes.push("have-start-date");
			}
			return classes.join(" ");
		},

		availableStartDateObjects() {
			const set = new Set();
			this.availableStartDates.forEach((dateStr) => {
				set.add(new Date(dateStr));
			});
			return set;
		},

		availableEndDateObjects() {
			const set = new Set();
			this.availableEndDates.forEach((dateStr) => {
				set.add(new Date(dateStr));
			});
			return set;
		},

		isDatesValid() {
			if (!this.datepickerStartDate || !this.datepickerEndDate) return false;
			if (
				this.datepickerStartDate.getTime() === this.datepickerEndDate.getTime()
			)
				return false;

			return true;
		},

		datepickerOptions() {
			return {
				format: "dd/mm/yyyy",
				language: this.language,
				orientation: "bottom",
				prevArrow: `
                <svg  width=12 height=12 class="icon">
                    <use xlink:href="#___icon___chevron-left-bold"></use>
                </svg>
                `,
				nextArrow: `
                <svg width=12 height=12 class="icon">
                    <use xlink:href="#___icon___chevron-right-bold"></use>
                </svg>
                `,
				todayHighlight: false,
				datesEnabled:
					this.datepickerOpen === "start"
						? this.availableStartDateObjects
						: this.availableEndDateObjects,
				container: "#datepicker-container",
				autohide: false,
				// clearBtn: true,
				// daysOfWeekHighlighted:[0,6],
			};
		},

		service() {
			return async (params) => {
				if (this.datepickerOpen === "start") {
					this.setLoading(true);
					const res = await window.searchEngineService.getStartDates(params);
					this.setLoading(false);
					return res;
				} else if (this.datepickerOpen === "end") {
					this.setLoading(true);
					const res = await window.searchEngineService.getRelatedPackages(params, 'getEndDates')
					this.setLoading(false);
					return res;
				}
			};
		},

		// dates that are currently in the url
		currentStartDateInURL() {
			const [day, month, year] = this.dates["BeginDate"].split("/");
			return new Date(`${year}-${month}-${day}`);
		},
		currentEndDateInURL() {
			const [day, month, year] = this.dates["EndDate"].split("/");
			return new Date(`${year}-${month}-${day}`);
		},
	},

	methods: {
		async getDateRangePickerClass() {
			if (!this.libs.DateRangePicker) {
				const DateRangePicker = await window.moduleLoader.getDatepicker();
        		this.libs.DateRangePicker = DateRangePicker;
			}
			return this.libs.DateRangePicker;
		},

		// ####################################################
		// helpers
		// ####################################################

		showDropdown(display = "block") {
			this.$refs["datepicker-wrapper"].style.display = display;
		},
		hideDropdown() {
			this.$refs["datepicker-wrapper"].style.display = "none";
		},
		setDatepickerOpen(newStr) {
			this.$store.dispatch("setDatepickerOpen", newStr);
		},
		handleClose() {
			this.setDatepickerOpen("");
		},
		resetRequestedStartDates() {
			this.$store.commit("setAvailableStartDateResponses", {});
		},
		resetRequestedEndDates() {
			this.$store.commit("setAvailableEndDateResponses", {});
		},
		resetRequestedDates() {
			this.resetRequestedStartDates();
			this.resetRequestedEndDates();
		},
		setCurrentFocusedDate(date) {
			if (!date) {
				// in case date is undefined - because focused date cannot be empty, it should default to a value, therefore I am resetting to date from url
				this.resetCurrentFocusedDate();
			} else {
				this.$store.commit("setCurrentFocusedDate", date);
			}
		},
		resetCurrentFocusedDate() {
			this.setCurrentFocusedDate(this.currentStartDateInURL);
		},
		setLoading(bool) {
			this.$store.commit("setDatepickerLoading", bool);
		},
		setSelectedStartDateInDatepicker(newStartDate) {
			if (!this.daterangepicker) return;
			const [_, selectedEndDate] = this.daterangepicker.getDates();
			if (newStartDate) {
				this.daterangepicker.setDates(newStartDate, selectedEndDate);
			} else {
				this.daterangepicker.setDates({ clear: true }, selectedEndDate);
			}
		},
		setSelectedEndDateInDatepicker(newEndDate) {
			if (!this.daterangepicker) return;
			const [selectedStartDate, _] = this.daterangepicker.getDates();
			if (newEndDate) {
				this.daterangepicker.setDates(selectedStartDate, newEndDate);
			} else {
				this.daterangepicker.setDates(selectedStartDate, { clear: true });
			}
		},

		// ####################################################
		// interactions with Vanilla Datepicker
		// ####################################################
		clearDatesInVanillaDatepicker() {
			this.daterangepicker.setDates({ clear: true }, { clear: true });
		},
		refreshVanillaDatepickerDatesIntoState() {
			// takes dates from datepicker and saves in Vue state (Vuex store)
			if (!this.daterangepicker) return;

			const [startDate, endDate] = this.daterangepicker.getDates();

			this.$store.commit("setDatepickerStartDate", startDate);
			this.$store.commit("setDatepickerEndDate", endDate);
		},
		setDatepickerActiveInVanillaDatepicker() {
			// the datepicker is an external script, so it needs manual controlling like this
			if (this.datepickerOpen === "start") {
				this.endDatepickerOpen = false;
				this.daterangepicker.datepickers[0].show();
				this.daterangepicker.datepickers[1].hide();
			} else if (this.datepickerOpen === "end") {
				this.endDatepickerOpen = true;
				this.daterangepicker.datepickers[0].hide();
				this.daterangepicker.datepickers[1].show();
			} else {
				this.daterangepicker.datepickers[0].hide();
				this.daterangepicker.datepickers[1].hide();
			}
		},
		setListenersOnVanillaDatepicker() {
			const datepicker_start = this.daterangepicker.datepickers[0];
			const datepicker_end = this.daterangepicker.datepickers[1];

			datepicker_start.element.addEventListener("changeDate", () => {
				const [startDate, _] = this.daterangepicker.getDates();
				if (this.datepickerOpen === "start" && startDate) {
					this.$store.commit("setDatepickerStartDate", startDate);
					this.setDatepickerOpen("end");
				}
			});

			datepicker_end.element.addEventListener("changeDate", () => {
				const dates = this.daterangepicker.getDates();
				if (dates[1]) {
					this.$store.commit("setDatepickerEndDate", dates[1]);
				}
			});

			datepicker_start.element.addEventListener("prevBtnClick", async () => {
				datepicker_start.goToPrev();
				await this.handleMonthChangeInVanillaDatepickerView();
			});
			datepicker_start.element.addEventListener("nextBtnClick", async () => {
				datepicker_start.goToNext();
				await this.handleMonthChangeInVanillaDatepickerView();
			});
			datepicker_end.element.addEventListener("prevBtnClick", async () => {
				datepicker_end.goToPrev();
				await this.handleMonthChangeInVanillaDatepickerView();
			});
			datepicker_end.element.addEventListener("nextBtnClick", async () => {
				datepicker_end.goToNext();
				await this.handleMonthChangeInVanillaDatepickerView();
			});
			datepicker_start.element.addEventListener(
				"changeViewToDays",
				async () => {
					await this.handleMonthChangeInVanillaDatepickerView();
				}
			);
			datepicker_end.element.addEventListener("changeViewToDays", async () => {
				await this.handleMonthChangeInVanillaDatepickerView();
			});

			datepicker_end.element.addEventListener("startDayClick", () => {
				this.setDatepickerOpen("start");
			});
			datepicker_end.element.addEventListener("dayClick", () => {
				this.$nextTick(this.handleValidateBtnClick);
			});
		},
		async handleMonthChangeInVanillaDatepickerView() {
			this.setCurrentFocusedDate(this.getCurrentViewDateOfVanillaDatepicker());
			await this.loadDates();
			await this.refreshVanillaDatepicker();
		},
		goToDateInVanillaDatepicker(datepickerIndex, date) {
			this.daterangepicker.datepickers[datepickerIndex].goToDate(date);
		},
		getCurrentViewDateOfVanillaDatepicker() {
			const pickerIndex = this.datepickerOpen === "start" ? 0 : 1;
			const currentViewDateTimestamp =
				this.daterangepicker.datepickers[pickerIndex].picker.viewDate;
			return new Date(currentViewDateTimestamp);
		},
		async refreshVanillaDatepicker() {
			if (this.daterangepicker) {
				this.daterangepicker.setOptions(this.datepickerOptions);
				this.daterangepicker.refresh();
				if (this.currentFocusedDate)
					this.daterangepicker.changeFocus(this.currentFocusedDate);
				this.setDatepickerActiveInVanillaDatepicker();
			} else {
				const DateRangePicker = await this.getDateRangePickerClass();
				if (this.daterangepicker) this.daterangepicker.destroy(); // because of asynchronicity it coult be created twice, so this is a hotfix
				const daterangepicker = new DateRangePicker(
					this.$refs["datepicker-wrapper"],
					this.datepickerOptions
				);
				this.daterangepicker = daterangepicker;
				this.setListenersOnVanillaDatepicker();
				this.setDatepickerActiveInVanillaDatepicker();
			}
		},

		// ####################################################
		// requesting more dates
		// ####################################################

		getFormattedMonthForRequest(date) {
			const monthStr =
				`${date.getMonth() + 1}`.length === 1
					? `0${date.getMonth() + 1}`
					: `${date.getMonth() + 1}`;
			return `${date.getFullYear()}-${monthStr}`;
		},
		getFormattedNextMonthForRequest(date) {
			const monthStr =
				`${date.getMonth() + 1}`.length === 1
					? `0${date.getMonth() + 1}`
					: `${date.getMonth() + 1}`;
			const nextMonthInt =
				parseInt(monthStr) === 12 ? 1 : parseInt(monthStr) + 1;
			const nextMonthYear =
				nextMonthInt === 1 ? date.getFullYear() + 1 : date.getFullYear();
			const nextMonthStr =
				`${nextMonthInt}`.length === 1 ? `0${nextMonthInt}` : `${nextMonthInt}`;
			return `${nextMonthYear}-${nextMonthStr}`;
		},
		getRequestParamsForMonth(month) {
			return {
				liheId: this.liheData.id,
				packCode: this.packCode,
				month: month,
				locale: this.locale,
				season: this.season,
			};
		},
		async loadDates() {
			if (!this.daterangepicker)
				throw new Error("cannot load dates when daterangepicker doesn't exist");

			if (this.datepickerOpen === "start") {
				// startDate param is necessary for end dates endpoint
				await this.loadStartDates();
			} else {
				await this.loadEndDates();
			}
		},
		async loadStartDates() {
			let res;

			// get months and params
			const currentMonth = this.getFormattedMonthForRequest(
				this.currentFocusedDate
			);
			const currentMonthParams = this.getRequestParamsForMonth(currentMonth);

			res = await this.service(currentMonthParams);
			this.saveResponse(res, currentMonthParams.month);
		},
		async loadEndDates() {
			// Some code in this method was commet out because of the new rule, for more informations, check the README file at frontend\src\services\README.md
			let res;

			// get months and params
			const currentMonth = this.getFormattedMonthForRequest(
				this.datepickerStartDate || this.currentFocusedDate
			);
			const currentMonthParams = this.getRequestParamsForMonth(currentMonth);
			// const nextMonth = this.getFormattedNextMonthForRequest(this.datepickerStartDate || this.currentFocusedDate);
			// const nextMonthParams = this.getRequestParamsForMonth(nextMonth);

			if (!this.datepickerStartDate) {
				this.$store.commit(
					"setDatepickerStartDate",
					this.currentStartDateInURL
				);
			}
			const startDate = this.datepickerStartDate;

			const startMonth = this.getFormattedMonthForRequest(startDate);
			const dayStr =
				startDate.getDate() < 10
					? "0" + startDate.getDate()
					: startDate.getDate();
			const startDateStr = `${startMonth}-${dayStr}`;

			currentMonthParams["startDate"] = startDateStr;
			// nextMonthParams["startDate"] = startDateStr;

			res = await this.service(currentMonthParams);
			this.saveResponse(res, currentMonthParams.month);
			// if (res.length === 0) {
			// res = await this.service(nextMonthParams);
			// this.saveResponse(res, nextMonthParams.month);
			// }
		},

		// ####################################################
		// save response in Vuex store
		// ####################################################

		saveResponse(res, monthStr) {
			if (this.datepickerOpen === "start") {
				const obj = { ...this.availableStartDateResponses };
				obj[monthStr] = res;
				this.$store.commit("setAvailableStartDateResponses", obj);
			}
			if (this.datepickerOpen === "end") {
				const obj = { ...this.availableEndDateResponses };
				obj[monthStr] = res;
				this.$store.commit("setAvailableEndDateResponses", obj);
			}
		},

		// ####################################################
		// open state change handlers
		// ####################################################

		async openHandler_fromOpenToClosed() {
			this.resetRequestedEndDates();
			this.$store.commit("setDatepickerStartDate", this.currentStartDateInURL);
			this.$store.commit("setDatepickerEndDate", this.currentEndDateInURL);
			this.resetCurrentFocusedDate();
			this.hideDropdown();
		},

		async openHandler_fromClosedToStart() {
			this.resetRequestedEndDates();
			this.resetCurrentFocusedDate();
			await this.refreshVanillaDatepicker();
			this.$store.commit("setDatepickerStartDate", null);
			this.$store.commit("setDatepickerEndDate", null);
			this.showDropdown();
			await this.loadDates();
			await this.refreshVanillaDatepicker();
		},

		async openHandler_fromClosedToEnd() {
			this.resetCurrentFocusedDate();
			await this.refreshVanillaDatepicker();
			this.showDropdown();
			await this.loadDates();
			await this.refreshVanillaDatepicker();
		},

		async openHandler_fromStartToEnd() {
			this.resetCurrentFocusedDate();
			await this.refreshVanillaDatepicker();
			await this.loadDates();
			const firstEndDate = this.availableEndDates[0];
			if (firstEndDate) {
				this.goToDateInVanillaDatepicker(1, new Date(firstEndDate));
				this.setCurrentFocusedDate(new Date(firstEndDate));
			} else {
				this.$store.commit(
					"setDatepickerStartDate",
					this.currentStartDateInURL
				);
				this.$store.commit("setDatepickerEndDate", this.currentEndDateInURL);
			}
			await this.refreshVanillaDatepicker();
		},

		async openHandler_fromEndToStart() {
			this.resetRequestedEndDates();
			this.refreshVanillaDatepicker();
			this.$store.commit("setDatepickerStartDate", null);
			this.$store.commit("setDatepickerEndDate", null);
			await this.loadDates();
			await this.refreshVanillaDatepicker();
		},

		// ####################################################
		// VALIDATE CLICK
		// ####################################################

		handleValidateBtnClick() {
			if (!this.isDatesValid) return;

			const startValue = this.$refs["start-date"].value;
			const endValue = this.$refs["end-date"].value;

			const datesObj = {
				BeginDate: startValue,
				EndDate: endValue,
			};

			this.$store.dispatch("setDates", datesObj); // the dispatch will close the dropdown, so no need to do anything
		},
	},
	watch: {
		datepickerOpen: async function (newValue, oldValue) {
			if (!newValue && oldValue) {
				await this.openHandler_fromOpenToClosed();
			} else if (newValue === "start" && !oldValue) {
				await this.openHandler_fromClosedToStart();
			} else if (newValue === "end" && !oldValue) {
				await this.openHandler_fromClosedToEnd();
			} else if (newValue === "start" && oldValue === "end") {
				await this.openHandler_fromEndToStart();
			} else if (newValue === "end" && oldValue === "start") {
				await this.openHandler_fromStartToEnd();
			}
			this.refreshVanillaDatepickerDatesIntoState();
		},

		availableStartDateObjects: async function () {
			if (!this.datepickerOpen) return;
			await this.refreshVanillaDatepicker();
		},

		availableEndDateObjects: async function () {
			if (!this.datepickerOpen) return;
			await this.refreshVanillaDatepicker();
		},

		datepickerStartDate: function () {
			this.setSelectedStartDateInDatepicker(this.datepickerStartDate);
		},
		datepickerEndDate: function (newVal, oldVal) {
			this.setSelectedEndDateInDatepicker(this.datepickerEndDate);
		},
	},

	async mounted() {
		if (this.datepickerOpen) {
			this.$refs["datepicker-wrapper"].style.display = "block";
			this.$refs["datepicker-wrapper"].style.opacity = "1";
		}
	},
};
</script>

<style scoped>
.planning-range-dropdown {
	z-index: 100001 !important;
}
</style>
